import scrollbarWidth from '@/functions/scrollbarWidth'

export default {
  /**
   * Disable scrolling
   */
  disable () {
    document.body.style.paddingRight = scrollbarWidth() + 'px'
    document.body.style.overflowY = 'hidden'
  },

  /**
   * Enable scrolling
   */
  enable () {
    document.body.style.paddingRight = ''
    document.body.style.overflowY = ''
  }
}
